module.exports = __webpack_public_path__ + "static/img/load_s.4b144bfe.svg";